var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1338 8.22751C15.1338 12.1674 11.9399 15.3613 8.00003 15.3613C4.06016 15.3613 0.866272 12.1674 0.866272 8.22751C0.866272 4.28764 4.06016 1.09375 8.00003 1.09375C11.9399 1.09375 15.1338 4.28764 15.1338 8.22751Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.96002C4.53855 1.96002 1.73248 4.76609 1.73248 8.22754C1.73248 11.689 4.53855 14.4951 8 14.4951C11.4615 14.4951 14.2675 11.689 14.2675 8.22754C14.2675 4.76609 11.4615 1.96002 8 1.96002ZM0 8.22754C0 3.80926 3.58172 0.227539 8 0.227539C12.4183 0.227539 16 3.80926 16 8.22754C16 12.6458 12.4183 16.2275 8 16.2275C3.58172 16.2275 0 12.6458 0 8.22754Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 3.53967C8.33769 3.53967 8.61145 3.81344 8.61145 4.15114L8.61145 8.22757C8.61145 8.56527 8.33769 8.83904 7.99998 8.83904C7.66228 8.83904 7.38852 8.56527 7.38852 8.22757L7.38852 4.15114C7.38852 3.81343 7.66228 3.53967 7.99999 3.53967Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6688 8.22752C11.6688 8.56523 11.3951 8.83899 11.0574 8.83899H8.00003C7.66233 8.83899 7.38857 8.56523 7.38857 8.22752C7.38857 7.88982 7.66233 7.61606 8.00003 7.61606H11.0574C11.3951 7.61606 11.6688 7.88982 11.6688 8.22752Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon_time.fa31148378a21b617a6cb33c40c158ab.svg";
export { ForwardRef as ReactComponent };